<template>
  <div class="home">
    <div class="carouselContain">
      <el-carousel height="270px" @change="changeCarousel">
        <el-carousel-item v-for="(l, i) in list" :key="i">
          <el-image :src="l.imgUrl" fit="cover" class="bannerBox"></el-image>
          <div :class="classObject">
            <div :class="mobile() ? 'titleOneSmall' : 'titleOne'">
              {{ l.titleOne }}
            </div>
            <div :class="mobile() ? 'titleTwoSmall' : 'titleTwo'">
              {{ l.titleTwo }}
            </div>
            <div :class="mobile() ? 'titleTwoSmall' : 'titleTwo'">
              {{ l.titleThree }}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div :class="mobile() ? 'infoContainSmall' : 'infoContain'">
      <div class="line"></div>
      <div class="infoContainOne">
        <h2 class="businessDescription">開発理念</h2>
        <p class="pOne">
          匠芯株式会社は、安心安全なソフトウェア構築を目指し、人材提供、受託開発、技術サポートを行っています。
        </p>
        <p class="pTwo">
          ソフトウェアの開発は、設計から実装、運用まですべての段階で安全面を意識しなければいけません。<br />
          匠芯株式会社は、お客様のデータ情報を丁寧に扱い、いつも安心、安全なソフトウェアを提供いたします。
        </p>
      </div>
      <div class="line"></div>
      <div>
        <h2 class="businessDescription">ニュースリリース</h2>
        <div class="infoSpan">
          <div class="infoSpanleft">2022/11/22</div>
          <div class="infoSpanright">日本・匠芯株式会社を設立しました</div>
        </div>
        <div class="infoSpan">
          <div class="infoSpanleft">2021/3/3</div>
          <div class="infoSpanright">
            中国・武漢匠芯軟件技術有限公司を設立しました
          </div>
        </div>
        <div class="infoSpan">
          <div class="infoSpanleft">2018/10/15</div>
          <div class="infoSpanright">
            中国・武漢匠芯ネットワーク科技有限公司を設立しました
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div :class="mobile() ? '' : 'bottomInfo'">
        <div :class="mobile() ? 'bottomInfoLeftSmall' : 'bottomInfoLeft'">
          <h2 class="businessDescription">事業情報</h2>
          <p class="pOne">
            匠芯株式会社は下記のビジネス中心に事業展開しています。
          </p>
          <div class="p-3">
            <div class="pTwo d-flex mb">
              <div class="round mr-1"></div>
              ソフトウェアの設計・開発・システム保守業務
            </div>
            <div class="pTwo d-flex mb">
              <div class="round mr-1"></div>
              IT技術者の請負、委託業務
            </div>
            <div class="pTwo d-flex mb">
              <div class="round mr-1"></div>
              スマホアプリ開発(iOS、Android)
            </div>
            <div class="pTwo d-flex mb">
              <div class="round mr-1"></div>
              DXコンサルティング、DXサービス開発
            </div>
            <div class="pTwo d-flex mb">
              <div class="round mr-1"></div>
              クラウド構築や移行サービス業務
            </div>
            <div class="pTwo d-flex">
              <div class="round mr-1"></div>
              IOT事業業務
            </div>
          </div>
        </div>
        <div class="bottomInfoRight">
          <h2 class="businessDescription">資料請求</h2>
          <div class="dataRequest d-flex pTwo">
            <i class="iconfont icon-youxiang icon-color font-14 mr"></i>
            <span class="mr-1">メール:</span>
            <span>info@jumsoft.co.jp</span>
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      classObject: "",
      list: [
        {
          imgUrl: require("@/assets/bannerFive.jpg"),
          titleOne: "JumSoftの",
          titleTwo: "未来のＩＴ方式はどういうふに考えべき",
          titleThree: "どのような姿を快適な革新世界へ抱えてる",
        },
        {
          imgUrl: require("@/assets/bannerFour.jpg"),
          titleOne: "JumSoftの",
          titleTwo: "未来に向け技術創新を抱える",
          titleThree: "最適なソリューションズを提供していく",
        },
        {
          imgUrl: require("@/assets/bannerTwo.jpg"),
          titleOne: "JumSoftの",
          titleTwo: "IT BUSINESSとは",
          titleThree: "BUILD WIN TO WIN SHIP",
        },
      ],
    };
  },
  created() {
    console.log(this.mobile());
  },
  methods: {
    changeCarousel(val) {
      console.log(val, "走马灯");
      if (val === 0) {
        this.classObject = "title animated zoomIn";
      } else if (val === 1) {
        this.classObject = "title animated fadeInRight";
      } else {
        this.classObject = "title animated rotateIn";
      }
    },
  },
};
</script>

<style scoped>
.carouselContain {
  margin-top: 42px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.bannerBox {
  width: 100%;
  height: 100%;
}

.d-flex {
  display: flex;
  align-items: center;
}

.line {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #eee;
}

.businessDescription {
  border-left: 5px solid #0071c5;
  padding-left: 12px;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

.pOne {
  font-size: 12px;
  color: #333;
}

.pTwo {
  font-size: 12px;
  color: #333;
}

.infoSpan {
  display: flex;
  align-items: center;
  border-top: 1px solid #eee;
  box-sizing: border-box;
  padding: 8px;
}

.infoSpan:hover {
  background-color: #f5f5f5;
}

.infoSpanleft {
  font-size: 12px;
  color: #333;
  width: 120px;
}

.infoSpanright {
  font-size: 12px;
  color: #333;
  flex: 1;
}

.bottomInfo {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.bottomInfoLeftSmall {
  width: 100%;
}

.bottomInfoLeft {
  width: 67%;
}

.round {
  width: 4px;
  height: 4px;
  background: black;
  border-radius: 50%;
}

.mr-1 {
  margin-right: 10px;
}

.p-3 {
  padding: 0px 30px;
}

.mb {
  margin-bottom: 5px;
}
.emailImg {
  width: 30px;
  height: 30px;
}
.titleOne {
  font-size: 34px;
  color: #fff;
}
.titleOneSmall {
  font-size: 28px;
  color: #fff;
}
.titleTwo {
  font-size: 20px;
  color: #fff;
}
.titleTwoSmall {
  font-size: 16px;
  color: #fff;
}
.title {
  position: absolute;
  bottom: 20px;
  left: 30px;
}
.animated {
  animation-duration: 2s;
  animation-fill-mode: both;
  /* animation-iteration-count:1; */
}
.zoomIn {
  animation-name: zoomIn;
}
@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.2, 0.2, 0.2);
  }
  50% {
    opacity: 1;
  }
}
.fadeInRight {
  animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
.rotateIn {
  animation-name: rotateIn;
}
@keyframes rotateIn {
  0% {
    transform-origin: center;
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }
  100% {
    transform-origin: center;
    transform: none;
    opacity: 1;
  }
}
</style>
